import type { Creation, CreationVersion } from '@djgg/creations';
import type { Callables } from '../services/types.js';

export function newBuildCommandId(): string {
  const id = globalThis.crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  return `studio-${id}`;
}

/**
 * The one request that builds a failed composed version again (requestBuild's
 * composed retry): the server re-admits that version's exact accepted
 * composition, resumes its finished media and calls no model to write code.
 * A failed first build and a failed revision of the live game share it; the
 * server repeats every check (member or attributed admin, the live version the
 * failed build was made from). One command id per click.
 */
export function composedRetryBuildRequest(
  creation: Pick<Creation, 'designRev' | 'settingsRev' | 'activeVersion'> & { id: string },
  failed: Pick<CreationVersion, 'prompt'>,
  commandId: string,
  attributeTo: string | undefined,
): Parameters<Callables['requestBuild']>[0] {
  return {
    commandId,
    creationId: creation.id,
    prompt: failed.prompt,
    expectedDesignRev: creation.designRev ?? 0,
    expectedSettingsRev: creation.settingsRev ?? 0,
    expectedActiveVersion: creation.activeVersion,
    creationExperience: 'deej-led',
    ...(attributeTo ? { attributeTo } : {}),
  };
}
